import { useModal } from './useModal';
import ModalLoading from '~/modules/common/components/modals/ModalLoading.vue';

export function useLoading() {
  const { openModal, closeModal } = useModal();
  /**
   * Show Loading
   */
  const start = () => {
    return openModal(ModalLoading);
  };

  /**
   * Hide Loading
   */
  const stop = () => {
    return closeModal(ModalLoading);
  };

  return { start, stop };
}
